import React, { useEffect } from 'react';

const Testimonials = () => {
  useEffect(() => {
    // Initialize Swiper for testimonials
    if (window.Swiper) {
      const swiperConfig = {
        loop: true,
        speed: 600,
        autoplay: {
          delay: 4000
        },
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        pagination: {
          el: '.testimonials-slider .swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 30
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      };

      const swiperElement = document.querySelector('.testimonials-slider.init-swiper');
      if (swiperElement && !swiperElement.swiper) {
        new window.Swiper(swiperElement, swiperConfig);
      }
    }
  }, []);

  const testimonials = [
    {
      name: 'Jennifer Martinez',
      role: 'CTO',
      company: 'TechFlow Inc',
      image: '/images/person-f-12.webp',
      text: 'Rettiyon Global delivered our new customer portal on time and within budget. The team understood our domain and brought strong architecture and security practices from day one.'
    },
    {
      name: 'Alexander Chen',
      role: 'Head of Engineering',
      company: 'DataScale',
      image: '/images/person-m-11.webp',
      text: 'We partnered with Rettiyon Global for our cloud migration. They handled the lift-and-shift and refactored critical services. Zero downtime, clear documentation, and responsive support.'
    },
    {
      name: 'Rachel Taylor',
      role: 'Product Director',
      company: 'HealthFirst',
      image: '/images/person-f-8.webp',
      text: 'Our patient-facing app needed a full redesign and rebuild. Rettiyon Global\'s UX and engineering teams worked closely with us—the result is fast, accessible, and compliant.'
    },
    {
      name: 'Christopher Lee',
      role: 'VP of Technology',
      company: 'FinServe',
      image: '/images/person-m-14.webp',
      text: 'We needed a secure, scalable backend for our new payments product. Rettiyon Global designed the system, implemented it, and helped us pass our first security audit.'
    },
    {
      name: 'Amanda Rodriguez',
      role: 'Operations Lead',
      company: 'LogiCore',
      image: '/images/person-f-5.webp',
      text: 'Rettiyon Global built our internal tools and integrations with our ERP. The team was easy to work with, and we now have a single source of truth across systems.'
    }
  ];

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>What clients say about working with us—delivery, quality, and partnership.</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="testimonials-slider swiper init-swiper">
          <div className="swiper-wrapper">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="swiper-slide">
                <div className="testimonial-card" data-aos="zoom-in" data-aos-delay={100 + (index * 100)}>
                  <div className="testimonial-header">
                    <div className="user-avatar">
                      <img src={testimonial.image} alt={testimonial.name} />
                    </div>
                    <div className="user-info">
                      <h3>{testimonial.name}</h3>
                      <span className="user-role">{testimonial.role}</span>
                      <div className="rating">
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <div className="quote-mark">
                      <i className="bi bi-quote"></i>
                    </div>
                    <p>{testimonial.text}</p>
                  </div>
                  <div className="testimonial-footer">
                    <div className="company-badge">
                      <i className="bi bi-building"></i>
                      <span>{testimonial.company}</span>
                    </div>
                    <div className="verified-badge">
                      <i className="bi bi-patch-check-fill"></i>
                      <span>Verified</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
